import { useEffect, useRef } from "react"
import styled from "styled-components"

const Wrap = styled.div`
    position: relative;
    height: fit-content;
    width: fit-content;
    background-color: rgba(238, 238, 238, 1);
    border-radius: 100%;
    padding: 8px;

    svg {
        fill: none;
        transform: rotate(-90deg);
        transorm-origin: center;
        circle {
            width: 100%;
            height: 100%;
            stroke-width: 8;

            &.frame {
                stroke: rgba(132, 132, 132, 0.3);
            }

            &.bar {
                stroke-linecap: round;
                stroke: rgba(28, 195, 145, 1);
            }
        }
    }

    .value {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 12px;
        font-weight: 400;
        line-height: calc(19.2 / 12);
        text-align: center;

        .caption {
            @include caption;
            white-space: nowrap;
            color: rgba(132, 132, 132, 1);
        }

        > span {
            font-size: 20px;
            font-weight: 600;
            line-height: calc(22.4 / 16);
        }
    }
`

export default function CircleProgress({value=0, ...props}) {
    const wrapRef = useRef();
    const barRef = useRef();

    
    function progress(per) {
        const RADIUS = 54;
        const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
        const progress = per / 100;
        const dashoffset = CIRCUMFERENCE * (1 - progress);

        return {
            dashoffset: dashoffset,
            strokeDasharray: CIRCUMFERENCE,
        };
    }

    useEffect(() => {
        const attr = progress(value);
        
        barRef.current.style.strokeDasharray = attr.strokeDasharray;
        barRef.current.style.strokeDashoffset = attr.dashoffset;
    },[value]);

    return (
        <Wrap ref={wrapRef} data-progress={value}>
            <svg className="circle-progress" width="120" height="120" viewBox="0 0 120 120">
                <circle className="frame" cx="60" cy="60" r="54" stroke-width="12" />
                <circle ref={barRef} className="bar" cx="60" cy="60" r="54" stroke-width="12" />
            </svg>
            <strong className="value">
                <p className="caption">total score</p>
                <span>{value}</span>점
            </strong>
        </Wrap>
    )
}